import React from 'react'

const MyTasks = () => {
  return (
    <div>MyTasks</div>
  )
}

export default MyTasks